import { ENV } from "./environment";

export const JITSI_DOMAIN = ENV.jitsiDomain;

//SUB URLS
export const USERS_URL = "/api/test";
export const USER_ROLE_URL = "/api/userrole";
export const DOCTORS_URL = "/api/doctor";
export const EMPLOYEE_URL = "/api/employee";
export const AUTH_URL = "/api/auth";
export const DOCTOR_AUTH_URL = "/api/DoctorAuth";
export const EMPLOYEE_AUTH_URL = "/api/EmployeeAuth";
export const PASSWORD_URL = "/api/Password";
export const PATIENT_AUTH_URL = "/mobile/PatientAuth";
export const PATIENT_URL = "/api/patient";
export const PATIENT_HEALTH_URL = "/api/PatientHealth";
export const MESSAGE_ROOM_URL = "/api/messageroom";
export const BOOKED_APPOINTMENT_URL = "/api/bookedappointment";
export const BOOKED_APPOINTMENT_MEETING_URL = "/api/bookedappointmentmeeting";
export const BOOKED_APPOINTMENT_DOCUMENT_URL = "/api/bookedappointmentdocument";
export const AVAILABLE_APPOINTMENT_TIME_URL = "/api/availableappointmenttime";
export const AVAILABLE_APPOINTMENT_DAY_URL = "/api/AvailableAppointmentDay";
export const PRICE_URL = "/api/ServicePackage";
export const NOTIFICATION_MESSAGE_URL = "/api/notification";
export const ISSUE_URL = "/api/issue";
export const USER_FILE_URL = "/api/UserFile";
export const PUBLIC_FILE_URL = "/api/PublicFile";
export const HUB_URL = "/chathub";
export const VIDEOSDK_URL = "/api/videosdk"
export const NOTE_URL = "/api/note"
export const HANGFIRE_JOB_URL = "/api/hangfirejob"
export const ENABIZ_SKRS_URL = "/api/Skrs"
export const ENABIZ_URL = "/api/Enabiz"
export const ENABIZ_USS_URL = "/api/EnabizUss"
export const ENABIZ_RECETE_URL = "/api/Recete"
export const CKYS_URL = "/api/Ckys"
export const SERVICE_PACKAGE_URL = "/api/ServicePackage"
export const PROFESSION_URL = "/api/Profession"
export const SPECIALTY_ATTRIBUTE_URL = "/api/SpecialtyCategoryAttribute"
export const SPECIALTY_ATTRIBUTE_ITEM_URL = "/api/SpecialtyCategoryAttributeItem"
export const SPECIALTY_URL = "/api/Specialty"
export const TITLE_URL = "/api/Title"
/** @deprecated use PROFESSION_URL */
export const SPECIALTY_CATEGORY_URL = PROFESSION_URL
/** @deprecated use SPECIALTY_ATTRIBUTE_URL */
export const SPECIALTY_CATEGORY_ATTRIBUTE_URL = SPECIALTY_ATTRIBUTE_URL
/** @deprecated use SPECIALTY_ATTRIBUTE_ITEM_URL */
export const SPECIALTY_CATEGORY_ATTRIBUTE_ITEM_URL = SPECIALTY_ATTRIBUTE_ITEM_URL
/** @deprecated use SPECIALTY_URL */
export const SPECIALTY_BRANCH_URL = SPECIALTY_URL
/** @deprecated use TITLE_URL */
export const SPECIALTY_TITLE_URL = TITLE_URL
/** Doktor kayıt onayı / durum değişikliği (PendingReview → Approved|Rejected) */
export const DOCTOR_STATUS_CHANGE_URL = "/api/DoctorStatusChangeInfo";
/** @deprecated use DOCTOR_STATUS_CHANGE_URL — eski genel UserStatusChangeInfo endpoint'i değil */
export const USER_STATUS_CHANGE_URL = DOCTOR_STATUS_CHANGE_URL;
export const SERVICE_PURCHASE_URL = "/api/ServicePurchase";
export const SERVICE_REFUND_URL = "/api/ServiceRefund";
export const PATIENT_DIAGNOSIS_URL = "/api/PatientDiagnosis";
export const AUDIT_LOG_URL = "/api/auditlog";
export const ASSISTANT_URL = "/api/assistant";
export const APP_VERSION_URL = "/api/AppVersion";
export const DOCTOR_TRIAGE_URL = "/api/DoctorTriage";
export const LANGUAGE_URL = "/api/language";
export const JITSI_URL = "/api/jitsi";
export const USER_NOTIFICATION_SETTINGS_URL = "/api/UserNotificationSettings";
export const USER_PREFERENCES_URL = "/api/UserPreferences";
export const PUSH_NOTIFICATION_URL = "/api/PushNotification";
export const CARE_TEAM_URL = "/api/CareTeam";
